import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import IconBack from '../../assets/img/ic-back.png';
import {
  HeaderBar,
  HeaderTitle,
  HeaderSubtitle,
  HeaderBack,
  HeaderContent,
} from './style';

class Header extends Component {
  constructor() {
    super();
    this.goBack = this.goBack.bind(this); // i think you are missing this
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { title, subtitle, children, back, center } = this.props;
    return (
      <HeaderBar center={center}>
        {back && (
          <HeaderBack onClick={this.goBack}>
            <img src={IconBack} alt="" />
          </HeaderBack>
        )}
        <HeaderContent>
          <HeaderTitle>{title}</HeaderTitle>
          <HeaderSubtitle>{subtitle}</HeaderSubtitle>
        </HeaderContent>
        {children}
      </HeaderBar>
    );
  }
}

export default withRouter(Header);
